<template>
  <div class="block-coming-soon" :style="styles">
   <p class="coming-soon-title">Coming Soon</p>
   <p class="coming-soon-desc">暴露数の相性が占えるコーナーを準備中。お楽しみに！</p>
  </div>
</template>

<script>
export default {
  name: 'BlockComingSoon',
  props: {
   
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  },
  
  methods: {
    
  },
}
</script>

<style scoped lang="scss">
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.block-coming-soon{
  background: #fff;
  border-radius: 250px;
  width: 333px;
  text-align: center;
  height: 333px;
  margin: 20px auto 50px;
  padding: 115px 0px;

  .coming-soon-title{
    color: $l_col_keycolor;
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 40px;
  }
  .coming-soon-desc{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    padding: 0 30px;
    color: #32373f;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockComingSoon.vue